import { put, select, takeLatest } from 'redux-saga/effects'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { IDataPointsConfig, IServiceConfig } from '../../configurations/store/configurations.types'
import { PCRConstants } from '../../pcr/store/pcr.constants'
import { getDatapointsConfigSelector } from '../../configurations/selectors'
import {
  getFactorsAffectingCareState,
  setShowDispatchFactors,
  setShowFactors,
  setShowResponseSceneTransportFactors,
  setShowTurnAroundFactors,
} from '../store/factorsAffectingCare.actions'

export function* setFactorsAffectingCareConditionalValues() {
  const serviceConfig: IServiceConfig = yield select(getServiceConfigSelector)
  const datapointsConfig: IDataPointsConfig = yield select(getDatapointsConfigSelector)
  const { PR_DISP_DELAY, PR_TURNAROUND_DELAY } = serviceConfig
  const { DP_FACTORS, DP_PR_DISP_DELAY, DP_PR_TURNAROUND_DELAY } = datapointsConfig
  if (PR_DISP_DELAY === 1 || DP_PR_DISP_DELAY === 1) {
    yield put(setShowDispatchFactors(true))
  }
  if (DP_PR_TURNAROUND_DELAY === 1 || PR_TURNAROUND_DELAY === 1) {
    yield put(setShowTurnAroundFactors(true))
  }
  if (DP_FACTORS === 1) {
    yield put(setShowFactors(true))
    yield put(setShowResponseSceneTransportFactors(false))
  } else if (DP_FACTORS === 3) {
    yield put(setShowFactors(false))
    yield put(setShowResponseSceneTransportFactors(true))
  }
  yield put(getFactorsAffectingCareState())
}

export function* setFactorsAffectingCareConditionalValuesSaga() {
  yield takeLatest([PCRConstants.CREATE_PCR], setFactorsAffectingCareConditionalValues)
}
